<template>
    <modal :show="show" class="modal-footage-library">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Encoding Profile Modal </modal-header>
        </div>
        <div v-if="step === 1">
          <p>Please delete the highlighted comp names and reenter them correctly</p>
          <div class="form-group">
            <label for="master" class="control-label">Add composition names</label>
            <input type="text" class="form-control" placeholder="LHUAS-75_As.ae" id="locale" v-model="choices.locale">
            <button class="btn btn-sm btn-primary">Add</button>
          </div>
          <div class="form-group" >
            <label for="render_video_format" class="control-label">Target Compositions</label>
            <div class="compos">
              <p>LHS8912SAZ-32_1293_ASo-V1 <i class="fa fa-trash text-danger "></i> </p>
            </div>
            <div class="compos">
              <p>LHS8912SAZ-32_1293_ASo-V2 <i class="fa fa-trash text-danger "></i> </p>
            </div>
            <div class="compos">
              <p>LHS8912SAZ-32_1293_ASo-V3 <i class="fa fa-trash text-danger "></i> </p>
            </div>
          </div>
        </div>
        <div v-else-if="step === 2">
          <p>Step 2 of 5</p>
          <p>Please Select an existing encoding profile</p>
          <p>You can edit or add new profile in your project settings later in the process</p>
          <div class="form-group">
            <label for="master" class="control-label">Default and Saved Profiles</label>
            <select name=""  class="form-control"  id="" v-model="profile">
              <option value="">Encoding Profile 1 (MP4 600kbs)</option>
              <option value="">Encoding Profile 2 (MP5 860kbs)</option>
            </select>
          </div>
        </div>
        <div v-else-if="step === 3">
          <p>Step 3 of X</p>
          <p>Set variable elements</p>
          <div class="form-group">
            <label for="master" class="control-label">composition name</label>
             <select name=""  class="form-control"  id="" v-model="composition_name">
              <option value="Za_09LHUAS-75_As.ae">Za_09LHUAS-75_As.ae</option>
              <option value="">LHUAS-7589asC_As.ae</option>
            </select>
          </div>
          <div class="row">
            <div class="col-md-4">
              <small for="">Layer name in your compos</small>
              <input type="text" name="" class="form-control" placeholder="Headline 1" id="">
            </div>
            <div class="col-md-4">
              <small for="">New value or asset</small>
              <input type="text" name="" class="form-control" placeholder="Headline 1" id="">
            </div>
            <div class="col-md-2">
              <small for="">Type</small>
              <select name=""  class="form-control"  id="" v-model="composition_name">
                <option value="Text">Text</option>
                <option value="Image">Image</option>
                <option value="Audio">Audio</option>
                <option value="Video">Video</option>
            </select>
            </div>
            <div class="col-md-2"> <br>
              <button class="btn btn-sm btn-primary">ADD</button>
            </div>
          </div>
          <div class="form-group" >
            <label for="render_video_format" class="control-label">Target Compositions</label>
            <table class="table ctable">
              <tbody>
              <tr>
                <td>Subheadline</td>
                <td>Get the total row</td>
                <td>Text</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              <tr>
                <td>Subheadline</td>
                <td>Get the total row</td>
                <td>Text</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              <tr>
                <td>Subheadline</td>
                <td>Get the total row</td>
                <td>Text</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else-if="step === 4">
          <p>Step 4 of X</p>
          <p>Pluggins. If you use third party pluggins in your file please detail them below</p>
          <div class="row">
            <div class="col-md-10">
              <small>Exisiting Otomo Pluggins</small>
              <select name=""  class="form-control"  id="" v-model="composition_name">
                <option value="Video Copilot" selected>Video Copilot</option>
                <option value="">LHUAS-7589asC_As.ae</option>
              </select>
            </div>
            <div class="col-md-2"> <br>
              <button class="btn btn-sm btn-primary">ADD</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10">
                <small>Request Other Plugins to be installed on your project</small>
                <input type="text" name="" class="form-control" placeholder="Add plugin name and version here" id="">
            </div>
            <div class="col-md-2"> <br>
              <button class="btn btn-sm btn-primary">ADD</button>
            </div>
          </div> <br>
          <div class="form-group" >
            <table class="table ctable">
              <tbody>
              <tr>
                <td>Boris FX Sophire</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              <tr>
                <td>Ficker Freak</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else-if="step === 5">
          <p>Step 5 of 5</p>
          <p>Select or add your font used in this project.</p>
          <div class="row">
            <div class="col-md-10">
              <small>Exisiting Otomo fonts</small>
              <select name=""  class="form-control"  id="" v-model="composition_name">
                <option value="Ariel" selected>Ariel</option>
                <option value="">sans-serif</option>
              </select>
            </div>
            <div class="col-md-2"> <br>
              <button class="btn btn-sm btn-primary">ADD</button>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-10">
                <small>Add font names for us add to the project</small>
                <input type="text" name="" class="form-control" placeholder="Enter font name" id="">
            </div>
            <div class="col-md-2"> <br>
              <button class="btn btn-sm btn-primary">ADD</button>
            </div>
          </div> <br>
          <div class="form-group" >
            <table class="table ctable">
              <tbody>
              <tr>
                <td>Inter</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              <tr>
                <td>Impact</td>
                <td><i class="fa fa-trash text-danger "></i> </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div slot="modalFooter">
            <modal-footer :closeModal="close" cancelText="Cancel" :confirm="isReady? confirm : noConfirm" :confirmText="title" :confirmDisabled="!isReady"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_encoding_profile',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    masters: null,
    creativeUnitType: String
  },
  data: () => ({
    step: 1,
    title: 'Next',
    choices: {
      masterChosen: null,
      locale: null,
      width: null,
      height: null,
      render_video_duration: 8,
      render_video_fps: 15,
      render_video_format: 'mp4'
    }
  }),
  computed: {
    isReady () {
      // Validations here
      return true
    }
  },
  methods: {
    confirm () {
      if (this.step === 1) {
        console.log(this.step + ' step')
        this.step = 2
      } else if (this.step === 2) {
        console.log(this.step + ' step')
        this.step = 3
      } else if (this.step === 3) {
        console.log(this.step + ' step')
        this.step = 4
      } else if (this.step === 4) {
        console.log(this.step + ' step')
        this.step = 5
        this.title = 'Complete'
      }
    },
    close () {
      this.show = false
    },
    noConfirm () {
    },
    isValidNumber (inputNumber, min = 0) {
      return inputNumber !== '' && Number(inputNumber) >= min
    }
  }
}

</script>

<style lang="scss">
.compos{
  border-top:1px solid lightgrey;
}
.compos >p {
  margin: 8px 0px;
}
.compos >p>i {
  float:right;
  margin: 0px 10px;
}
.ctable{
  border:0px
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/encoding-profile/encoding-modal.vue